// extracted by mini-css-extract-plugin
export default {"mCard":"nD-z","image":"oD-z","imageNoBackground":"pD-z","imageHasCategory":"qD-z","fullWidth":"rD-z"};